import Box from "@mui/material/Box";

const VARIANT_CLASS = {
  success: "cj-status-badge--success",
  error: "cj-status-badge--error",
  warning: "cj-status-badge--warning",
  info: "cj-status-badge--info",
  neutral: "cj-status-badge--neutral",
};

/**
 * Style guide status pill (same metrics as `.jobber-status-pill` in MuiTable/style.css).
 * Table/list screens should use `JobberStatusBadge` (`MuiTable/index.jsx`): it renders this
 * component for all mapped tones and legacy spans only for `change` / `converted`.
 */
export default function StatusBadge({
  variant = "neutral",
  children,
  className = "",
  sx,
  component = "span",
  style,
  ...rest
}) {
  const mod = VARIANT_CLASS[variant] || VARIANT_CLASS.neutral;
  const cls = `cj-status-badge ${mod}${className ? ` ${className}` : ""}`;
  if (sx && typeof sx === "object" && Object.keys(sx).length > 0) {
    return (
      <Box
        component={component}
        className={cls}
        sx={sx}
        style={style}
        {...rest}
      >
        {children}
      </Box>
    );
  }
  const Comp = component;
  return (
    <Comp className={cls} style={style} {...rest}>
      {children}
    </Comp>
  );
}
